import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../api';

// ── 근로소득 간이세액표 갱신 리마인더 ────────────────────────────────────
// "매년 새 근로소득 간이세액표(소득세법 시행령 별표2)를 국세청이 배포하지만 자동으로
// 가져올 수는 없으니(로그인/캡차 등으로 자동조회 불가 — 4대보험 요율과 달리 공개 조회
// API/페이지가 없다), 매년 1월에 관리자가 개정 여부를 직접 확인하고 필요하면 새 파일을
// 업로드해달라"는 안내만 해주는 컴포넌트. StorageBackupReminderAlert.js와 동일하게
// 실시간 소켓 없이 화면 진입/마운트 시 1회 REST로 확인하는 방식만 사용한다 —
// GET /api/hr/income-tax-table/reminder가 로그인한 사용자가 최고관리자인지와 올해
// 1월에 아직 표를 갱신/확인하지 않았는지를 서버에서 판단해서 돌려준다.
export default function IncomeTaxTableReminderAlert() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null); // { show, lastUploadedAt }
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!user) return;
    API.get('/hr/income-tax-table/reminder')
      .then(res => { if (res.data?.show && !document.fullscreenElement) setInfo(res.data); })
      .catch(() => {});
  }, [user]);

  if (!info || dismissed) return null;

  const goCheck = () => {
    setDismissed(true);
    navigate('/hr-management', { state: { openIncomeTaxTable: true } });
  };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:3000,
      display:'flex', alignItems:'center', justifyContent:'center' }}
      onClick={() => setDismissed(true)}>
      <div style={{ background:'#fff', borderRadius:14, width:420, maxWidth:'90vw', padding:'26px 24px 22px' }}
        onClick={e => e.stopPropagation()}>
        <div style={{ fontSize:12.5, fontWeight:700, color:'#059669', marginBottom:8 }}>
          📄 근로소득 간이세액표 갱신 안내
        </div>
        <div style={{ fontSize:16.5, fontWeight:700, color:'#1a1a1a', marginBottom:8 }}>
          올해 근로소득 간이세액표를 아직 확인하지 않았습니다
        </div>
        <div style={{ fontSize:13, color:'#666', marginBottom:4 }}>
          마지막 등록: {info.lastUploadedAt || '등록 이력 없음'}
        </div>
        <div style={{ fontSize:12, color:'#999', marginTop:6, lineHeight:1.5 }}>
          국세청이 근로소득 간이세액표(소득세법 시행령 별표2)를 매년 초 새로 고시할 수 있습니다.
          자동으로 가져올 수 없는 문서라 관리자가 국세청 홈택스에서 개정 여부를 직접 확인해야
          합니다 — 개정판이 있으면 인사관리 &gt; 요율 관리에서 새 엑셀 파일을 업로드해주세요.
          변경이 없다면 그대로 두셔도 됩니다.
        </div>
        <div style={{ display:'flex', gap:8, marginTop:20 }}>
          <button onClick={goCheck}
            style={{ flex:1, padding:'11px', background:'#059669', color:'#fff', border:'none',
              borderRadius:8, fontSize:13, fontWeight:700, cursor:'pointer' }}>
            지금 확인
          </button>
          <button onClick={() => setDismissed(true)}
            style={{ flex:1, padding:'11px', background:'#fff', color:'#555', border:'1px solid #ddd',
              borderRadius:8, fontSize:13, fontWeight:600, cursor:'pointer' }}>
            나중에
          </button>
        </div>
      </div>
    </div>
  );
}
